import CONFIG from '../config'
import axios from 'axios'
import {promisifiedSocketEmit} from "../helpers";
import MAYA from "./index";

import {changeScannerServerStatus} from "../components/Devices/Scanner/modules/scanner";
import {getStore} from '../main';

const SCANNER = {
  checkConnected() {
    return doRequest('/device/get/connected', {}, 5500);
  },
  getDevices() {
    return doRequest('/device/get/devices');
  },
  doConnect(data) {
    return doRequest('/device/connect', data);
  },
  doDisconnect() {
    return doRequest('/device/disconnect');
  },
  doScan(data) {
    return doRequest('/device/scan', data);
  },
  addLog(data){
    createSecureEmit('/utils/scanner/log', {data});
  }
};

function doRequest(path, data = {}, timeout) {
  return new Promise((resolve, reject) => {

    const store = getStore();

    const options = {};
    if(timeout) options.timeout = timeout;

    axios.post(`${CONFIG.SCANNER_URL}${path}`, data, options)
      .then((result) => {

        //SCANNER.addLog(result);

        store.dispatch(changeScannerServerStatus(true));

        if (result.status !== 200) {
          throw new Error('Wrong response HTTP status code from scanner');
        }

        resolve(result.data)
      })
      .catch(() => {
        store.dispatch(changeScannerServerStatus(false));
        console.log('No connection established with scanner server')
      })
  })
}

const createSecureEmit = (path = '', params = {}) => promisifiedSocketEmit(path, {...MAYA.getCredentials(), ...params});

export default SCANNER;


// WEBPACK FOOTER //
// ./src/maya_api/scanner.js